import { IApplicationState } from '../../types/redux';

export const getIsPartnerRewardsRegistrationStatusAvailable = (state: IApplicationState) =>
  state.offersData.newbuildingBrokerCommon?.partnerRewardsRegistrationStatus === 'available';
